import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginPage } from './login';
import { RestProvider } from '../../providers/rest/rest';

@NgModule({
  declarations: [
    LoginPage,
  ],
  imports: [
    IonicPageModule.forChild(LoginPage),
  ],
  providers: [
    RestProvider,
  ]
})
export class LoginPageModule {}



// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts